import type { IBooleanResponse } from '@types'
import type { TPortfolioAsset } from '~/@types'
import type { TAssetFormDTO, TAssetType } from '~/@types/assets'
import Api from '@api/Api'

export default abstract class PortfolioAssetApi {
  public static getAsset(id: string): Promise<TPortfolioAsset> {
    return Api.get<TPortfolioAsset>(`/portfolio/asset/${id}`)
  }

  public static checkExistingRecord(assetType: TAssetType, symbol: string): Promise<TPortfolioAsset | null> {
    return Api.get<TPortfolioAsset | null>(`/portfolio/check-existing-record?symbol=${symbol}&type=${assetType}`)
  }

  public static createAsset(data: TAssetFormDTO): Promise<IBooleanResponse> {
    return Api.post<IBooleanResponse>('/portfolio/asset', data)
  }

  public static updateAsset(id: string, data: TAssetFormDTO): Promise<IBooleanResponse> {
    return Api.put<IBooleanResponse>(`/portfolio/asset/${id}`, data)
  }

  public static deleteAsset(id: string): Promise<IBooleanResponse> {
    return Api.delete<IBooleanResponse>(`/portfolio/asset/${id}`)
  }
}
